import { DeepPartial, FieldValues } from "react-hook-form";

import { FieldType } from "./types";

export const getNestedDefaultValue = <T extends FieldValues>(
  defaultValues: DeepPartial<T> | undefined,
  field: FieldType<T>,
): string => {
  if (!defaultValues) {
    return "";
  }

  const nestedKeys = field.key.split(".");

  let parent = defaultValues;
  while (nestedKeys.length > 0) {
    const key = nestedKeys.shift();
    if (!key) {
      return parent as unknown as string;
    }
    parent = parent[key];
  }

  return parent as unknown as string;
};
